import gql from 'graphql-tag';

export const GetUserQuery = gql`
  query getUserQuery {
    me {
      userProfile {
        id
        name
        email
        avatarUrl
        # Need organization here too for personal accounts
        # as they don't have a me { org } entity
        organization {
          id
          name
        }
      }
      organization {
        id
        name
        type
        isAdmin
      }
      roles {
        canImpersonate
      }
    }
  }
`;
